import { RichTextPreviewFormData } from './contracts';

export type RichTextPreviewProps = RichTextPreviewFormData;

export const RichTextPreview = ({ content }: RichTextPreviewFormData) => {
  return (
    <div
      className="richTextPreview"
      style={{ width: '100%' }}
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};
